import crowDefaultImage from './../../../../images/crowDefaultImage.png';

export default class Controller {

    static get $inject() {
        return [
            'ApiPanelsService', '$element', '$scope', '$rootScope', '$state', 'UiHelper'
        ];
    }

    constructor(ApiPanelsService, $element, $scope, $rootScope, $state, UiHelper) {

        // this.panel - value should be already defined in view from outside of component

        this.$rootScope = $rootScope;
        this._api = ApiPanelsService;
        this.$scope = $scope;
        this.UiHelper = UiHelper;

        this.perPage = 10;
        this.currentPage = 1;
        this.totalItems = 0;
        this.loading = false;
        this.reports = [];

        $scope.currentImage = {};
        $scope.currentPictures = [];
        $scope.crowDefaultImage = crowDefaultImage;
        $scope.imgError = function (source) {
            source.src = $scope.crowDefaultImage;
        };

        $scope.$watch('active', function (newIndex, oldIndex) {

            $scope.currentImage = $scope.currentPictures[newIndex];
        });

        $rootScope.$on('languageChanged', () => {
            $state.reload();
        });

        $element.on('$destroy', () => {
            this.UiHelper.closeModals();
        });

        this.socketEventReference = this.$rootScope.$on('socketEvent', (e, event) => {
            this.loadReports();
            this.$rootScope.$broadcast('newReport', event);
        });

        $element.on('$destroy', () => {
              this.socketEventReference();
        })

    }

    ifCidIsPicture(cid) {
        return +cid === 1 || +cid === 2 || +cid === 3 ? true : false;
    }

    pageChanged() {
        this.loadReports();
    }

    loadReports() {

        this.loading = true;

        if (this.panel) {
            this._api.reports(this.panel.control_panel.mac, this.currentPage, this.perPage)
                .then((r) => {
                    this.loading = false;

                    this.totalItems = r.data.count;
                    this.totalPages = Math.ceil(this.totalItems / this.perPage);
                    this.reports = r.data.results;

                })
                .catch((err) => {
                    this.loading = false;

                });
        }
    }

    // --- LifeCycle hooks ---

    $onInit() {
        this.pageChanged();
    }

    $onChanges(changesObj) {
        /* $onChanges(changesObj) - Called whenever one-way bindings are updated.
         * The changesObj is a hash whose keys are the names of the bound properties that have changed,
         * and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
         * Use this hook to trigger updates within a component such as
         * cloning the bound value to prevent accidental mutation of the outer value. */
    }

    castDateTime(dateTimeString) {

        return dateTimeString && new Date(dateTimeString);
    }

    setCurrentPicturesSet(picturesSet) {
        this.$scope.currentPictures = picturesSet;
        this.$scope.currentImage = this.$scope.currentPictures[0];
        this.UiHelper.showModal('picLightbox');
    }

}



/** WEBPACK FOOTER **
 ** ./src/main/panels/panel/reports.component/controller.js
 **/